var vms = vms || {};
vms.ir = vms.ir || {};

vms.connection.refresh_ir_report = function (pId) {
    if (pId) {
        $('#' + pId).trigger('apexrefresh');
    } else {
        $('#pgIR1').trigger('apexrefresh');
    }
}

vms.ir.btns = function (pIrId,pIrCode,pColspan) {
	var elements = document.querySelectorAll('#'+pIrId+' input[id^="recID"]');
	var recId, params;
		// Loop through the NodeList using forEach
		elements.forEach((element, index) => {
			recId = element.value;
			if (pIrCode == 'EXECUTED_WO') {
				params = element.getAttribute('vsm-project-type') + '~' +
						 element.getAttribute('vsm-manager') + '~' +
						 element.getAttribute('vsm-project-edit') + '~' +
						 element.getAttribute('vsm-is-offline') + '~' +
						 element.getAttribute('vsm-task-iit-id') + '~' +
						 element.getAttribute('vsm-task-nc') + '~' +
						 element.getAttribute('vsm-task-closed') + '~' +
						 element.getAttribute('vsm-task-deferred-date') + '~' +
						 element.getAttribute('vsm-task-project-id') + '~' +
						 element.getAttribute('vsm-task-profile-id') + '~' +
						 element.getAttribute('vsm-task-rci-id') + '~' +
						 element.getAttribute('vsm-task-checklist') + '~' +
						 element.getAttribute('vsm-task-rct-id') + '~' +
						 recId + '~' +
						 element.getAttribute('vsm-task-file-list') + '~' +
						 element.getAttribute('vsm-task-push');
			}
			else if (pIrCode == 'UNPLANNED_WO') {
				params = element.getAttribute('vsm-project-type') + '~' +
						 element.getAttribute('vsm-manager') + '~' +
						 element.getAttribute('vsm-project-edit') + '~' +
						 element.getAttribute('vsm-is-offline') + '~' +
						 element.getAttribute('vsm-task-iit-id') + '~' +
						 element.getAttribute('vsm-task-nc') + '~' +
						 element.getAttribute('vsm-task-closed') + '~' +
						 element.getAttribute('vsm-task-deferred-date') + '~' +
						 element.getAttribute('vsm-task-project-id') + '~' +
						 element.getAttribute('vsm-task-profile-id') + '~' +
						 element.getAttribute('vsm-task-file-list') + '~' +
						 element.getAttribute('vsm-task-cmt') + '~' +
						 element.getAttribute('vsm-task-chk') + '~' +
						 recId + '~' +
						 element.getAttribute('vsm-task-review-checklist') + '~' +
						 element.getAttribute('vsm-task-push'); 
			}
			else if (pIrCode == 'SCHEDULED_PROC') {
				params = recId + '~' +
						 element.getAttribute('vsm-rci-id') + '~' +
						 element.getAttribute('vsm-rct-id') + '~' +
						 element.getAttribute('vsm-edit') + '~' +
						 element.getAttribute('vsm-file-list');
			}
			else if (pIrCode == 'DPA_WO') {
				params = recId + '~' +
						 element.getAttribute('vsm-task-project-id') + '~' +
						 element.getAttribute('vsm-task-profile-id') + '~' +
						 element.getAttribute('vsm-task-file-list') + '~' +
						 element.getAttribute('vsm-task-cmt')+ '~' +
						 element.getAttribute('vsm-task-chk')+ '~' +
						 element.getAttribute('vsm-task-review-checklist');
				
			}
			console.log('params='+params);
			$("input[id*='icons"+recId+"']").closest('td').attr('rowspan', '2');
			//console.log('recId='+recId);
			// Generate Buttons
			apex.server.process("generateIrBtns", {
				x01: pIrCode,
				x02: pColspan,
				x03: params
			}, {
				dataType: "text",
				async: false,
				success: function (d) {
					//console.log('d='+d);
					$("input[id*='recID"+recId+"']").closest('tr').after(d);
				}
			});
		});
}

var refresh_ir_report = vms.connection.refresh_ir_report;